import React from 'react';
import ProjectCarousel from './ProjectCarousel';
import ImpactStats from './ImpactStats';
import HeroSection from './HeroSection';
import KenyaGlobe from './KenyaGlobe';
import KenyaMap3D from './KenyaMap3D'
import ArticlesSection from './ArticlesSection';
import Footer from './Footer';
import NewsSection from './NewsSection';
import KenyaShape from './KenyaShape';
import KenyaShapeB from './KenyaShapeB';
import KenyaProjectsMap from './KenyaProjectsMap';
import KenyaProjectsMapB from './KenyaProjectsMapB';
import KenyaProjectsMapC from './KenyaProjectMapC';
import KenyaProjectsMapD from './KenyaProjectMapD';
import KenyaProjectsMapE from './KenyaProjectMapE';
import KenyaProjectsMapF from './KenyaProjectMapF';
import KenyaProjectsMapG from './KenyaProjectMapG';
import KenyaProjectsMapH from './KenyaProjectMapH';

const HomeJ = () => {
  return (
    <div className="home-page">
      {/* Intro */}
      <section className="hero">
        <div className="hero-text">
          <h1>Together for a Just and Equal World</h1>
          <p>We are working to end poverty and injustice through empowering communities and advocating for lasting change.</p>
        </div>
        <img src="https://picsum.photos/800/300?random=1" alt="Hero" className="hero-img" />
      </section>

      {/* Latest News */}
      <section className="news">
        <h2>Latest News</h2>
        <div className="card-grid">
          {[2, 3, 4].map((n) => (
            <div className="card" key={n}>
              <img src={`https://picsum.photos/300/150?random=${n}`} alt="" />
              <h3>News Headline {n}</h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut orci vitae nisl dignissim fermentum.</p>
            </div>
          ))}
        </div>
      </section>

      {/* What we do */}
      <section className="areas-of-work">
        <h2>What we do</h2>
        <div className="card-grid">
          {[
            'Emergencies',
            "Women's rights",
            'Land and climate',
            'Politics and economics',
          ].map((title, i) => (
            <div className="card" key={i}>
              <img src={`https://picsum.photos/300/150?random=${10 + i}`} alt={title} />
              <h3>{title}</h3>
              <p>Short intro on how we work in the area of {title.toLowerCase()} and support people affected.</p>
              <a href="#">Learn more →</a>
            </div>
          ))}
        </div>
      </section>

      {/* Active Campaign */}
      <section className="campaign">
        <h2>Active Campaign</h2>
        <div className="campaign-box">
          <img src="https://picsum.photos/600/250?random=20" alt="Campaign" />
          <div className="campaign-content">
            <h3>Girls Not Brides: End Child Marriage</h3>
            <p>This campaign is fighting for the rights of girls to education, safety, and a future free from child marriage.</p>
            <button>Join Campaign</button>
          </div>
        </div>
      </section>

      {/* Where We Work */}
      <section className="map-section">
        <h2>Where We Work</h2>
        <img src="https://picsum.photos/800/200?random=21" alt="World Map" className="full-img" />
        <p>We are present in over 45 countries, supporting grassroots change and amplifying local voices.</p>
      </section>

      {/* Project Browse - GCF */}
      <section className="projects">
        <h2>Explore Projects</h2>
        <ProjectCarousel />
      </section>

      {/* Fund statistics */}
      <section className="stats">
        <h2>Funding Impact</h2>
        <div className="stats-grid">
          <div>
            <h3>$75M+</h3>
            <p>Invested in development programs</p>
          </div>
          <div>
            <h3>2M+</h3>
            <p>People directly supported</p>
          </div>
          <div>
            <h3>45</h3>
            <p>Countries impacted</p>
          </div>
        </div>
      </section>

      {/* Articles */}
      <section className="articles">
        <h2>Insights & Stories</h2>
        <div className="card-grid">
          {[22, 23, 24].map((n) => (
            <div className="card" key={n}>
              <img src={`https://picsum.photos/300/150?random=${n}`} alt="" />
              <h3>Story Title</h3>
              <p>Personal stories and in-depth articles from communities we work with.</p>
              <a href="#">Read More →</a>
            </div>
          ))}
        </div>
      </section>

      {/* Partners */}
      <section className="partners">
        <h2>Our Partners</h2>
        <div className="logo-grid">
          {[1, 2, 3, 4].map((n) => (
            <img
              key={n}
              src={`https://picsum.photos/100/50?random=${30 + n}`}
              alt="Partner logo"
            />
          ))}
        </div>
      </section>

      {/* Learn More */}
      <section className="learn-more">
        <h2>Learn More</h2>
        <div className="learn-box">
          <img src="https://picsum.photos/400/200?random=40" alt="Resources" />
          <div>
            <h3>Ultra Poor Graduation Program</h3>
            <p>This approach enables families to escape extreme poverty sustainably through livelihood support, training, and empowerment.</p>
            <a href="https://www.brac.net/program/ultra-poor-graduation/" target="_blank" rel="noreferrer">
              Explore Resource →
            </a>
          </div>
        </div>
      </section>

      <ImpactStats />
      <HeroSection />

      {/* <KenyaGlobe/> */}

      {/* <KenyaMap3D/> */}

      {/* <KenyaShape/> */}
      {/* <KenyaShapeB/> */}

      {/* <KenyaProjectsMap/> */}

      {/* <KenyaProjectsMapB/> */}

      {/* <KenyaProjectsMapC/> */}

      {/* <KenyaProjectsMapD/> */}

      {/* <KenyaProjectsMapE/> */}

      {/* <KenyaProjectsMapF/> */}
      {/* <KenyaProjectsMapG/> */}
      <KenyaProjectsMapH/>
      <ArticlesSection />
      <NewsSection/>
      {/* <Footer /> */}
    </div>
  );
};

export default HomeJ;
